var map = {
	"./tb_t-4_stitch_blk.png": 258155,
	"./tb_t-4_stitch_blu.png": 589109,
	"./tb_t-4_stitch_cml.png": 678938,
	"./tb_t-4_stitch_crk.png": 309248,
	"./tb_t-4_stitch_grn.png": 187393,
	"./tb_t-4_stitch_lgd.png": 156315,
	"./tb_t-4_stitch_lsl.png": 980463,
	"./tb_t-4_stitch_nvy.png": 864183,
	"./tb_t-4_stitch_orn.png": 561625,
	"./tb_t-4_stitch_pnk.png": 115747,
	"./tb_t-4_stitch_ppl.png": 913058,
	"./tb_t-4_stitch_red.png": 237775,
	"./tb_t-4_stitch_sax.png": 76810,
	"./tb_t-4_stitch_wht.png": 874565,
	"./tb_t-4_stitch_ylw.png": 554956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670007;